import PageComponent from './page';

const route = {
  Component: PageComponent,
  exact: true,
  id: PageComponent.displayName,
  path: '/',
};

export default route;
